<ui-page-container>
  <mat-card class="media-page-content">
    <mat-card-title>{{ 'Ruoli' | translate }}</mat-card-title>
    <mat-card-content>
      <ui-table
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [pager]="pager$"
        [reload]="reload$"
        [pagination]="false"
        [contextMenuActions]="contextMenus"
        (select)="selectHandler($event)"
        (rowAction)="manageRowActions($event)">
        <div tableActions>
          <app-entity-actions
            className="Role"
            [selectedItemsCount]="selectedItems?.length"
            [config]="{ showAddToCollection: false, showExport: false }"
            (add)="addHandler()"
            (delete)="deleteSelectedHandler()">
          </app-entity-actions>
        </div>
        <div tableFilters></div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
